<div class="card mb-4">
    <div class="card-body pb-5">
        <div class="mb-4">
            <h4 class="text-primary mb-0">Member Directory</h4>
        </div>

        <form [formGroup]="settingsForm" (ngSubmit)="onSaveClicked()" novalidate>

            <div class="mb-3">
                <div class="form-check form-switch fs-5">
                    <input type="checkbox"
                        id="isVisibleInDirectory"
                        class="form-check-input"
                        role="switch"
                        formControlName="isVisibleInDirectory" />
                    <label for="isVisibleInDirectory" class="form-check-label fw-semibold fs-6">
                        {{ MembersMessagingConstants.MEMBERS_DIRECTORY_VISIBILITY_LABEL() }}
                    </label>
                </div>
                <p class="text-muted small mb-0 mt-1">
                    {{ MembersMessagingConstants.MEMBERS_DIRECTORY_VISIBILITY_HELP() }}
                </p>
            </div>

            @if (!isVisibleInDirectory()) {
                <div class="alert alert-warning d-flex ms-icon-text gap-2" role="alert">
                    <fa-duotone-icon icon="eye-slash" secondaryOpacity="0.4" />
                    <div>{{ MembersMessagingConstants.MEMBERS_DIRECTORY_VISIBILITY_HIDDEN_WARNING() }}</div>
                </div>
            }

            <div class="d-flex justify-content-end gap-2 mt-4">
                <button type="button"
                    class="btn btn-ms-secondary"
                    [disabled]="isSubmitting() || !hasFormBeenModified()"
                    (click)="onResetClicked()">
                    Cancel
                </button>
                <button type="submit"
                    class="btn btn-primary"
                    [disabled]="isSubmitting() || !hasFormBeenModified()">
                    @if (isSubmitting()) {
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Saving...
                    } @else {
                        Save changes
                    }
                </button>
            </div>
        </form>
    </div>
</div>

<ms-info-modal #memberSettingsInfoModalRef
    modalId="memberSettingsInfoModal"
    (onConfirm)="onInfoModalConfirmed()"
/>
